/// <amd-module name="typeahead/core/message/FormSubmittedMessage" />

/// <reference path="../../../typings/typeahead/plugins.d.ts" />

import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";

export class FormSubmittedMessage implements TypeaheadMessage {

    public static getTopic(): string {
        return "typeahead.form_submitted";
    }

    constructor(private formValid: boolean, private context: IContext, private event?: JQueryEventObject) {}

    public getTopic(): string {
        return FormSubmittedMessage.getTopic();
    }

    public isFormValid(): boolean {
        return this.formValid;
    }

    public getContext(): IContext {
        return this.context;
    }

    public getEvent(): JQueryEventObject {
        return this.event;
    }
}
